import { toast } from 'sonner';

import { useCreateCustomerMutation } from '@/features/slice/customers/customer-api-slice';
import { useModal } from '@/hooks';
import { TCustomerForm } from '@/modules/customers';
import { toastError } from '@/utils';

export const useCreateCustomer = () => {
    const [createCustomer, { isLoading, isError, isSuccess }] =
        useCreateCustomerMutation();

    const { closeModal } = useModal();

    const onSubmit = async (values: TCustomerForm) => {
        try {
            await createCustomer(values).unwrap();
            closeModal();
            toast.success('Customer created successfully');
        } catch (error) {
            toastError(error, 'useCreateCustomer: onSubmit');
        }
    };

    return {
        onSubmit,
        isLoading,
        isError,
        isSuccess,
        closeModal,
    };
};
